"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationList = void 0;
var _PaginationList = require("./PaginationList");
// TODO: in v9, move styled() from PaginationList.jsx to here
var StyledPaginationList = _PaginationList.PaginationList;
exports.StyledPaginationList = StyledPaginationList;